var dropdownModule = (function () {

    function initializeSelect2Element(element) {
        
        var options = {
            theme: "bootstrap"
        };

        var placeholder = element.attr("placeholder");
        if (placeholder != undefined && placeholder.length > 0) {
            options.placeholder = placeholder;
            options.allowClear = true;
        }

        var hideSearch = element.data("app-dropdown-hide-search");
        if (hideSearch != undefined) {
            options.minimumResultsForSearch = Infinity;
        }

        element.select2(options);
    }

    function initSelect2() {
        $("select:not(.no-select2):not([data-app-dropdown-initialized])").each(function () {
            var element = $(this);
            initializeSelect2Element(element);
            element.data("app-dropdown-initialized", "");
        });
    }

    return {
        init: function() {
            initSelect2();
        },
        initSelect2: function(element) {
            initializeSelect2Element(element);
        }
    };
})();

exports.init = dropdownModule.init;
exports.initSelect2 = dropdownModule.initSelect2;


/*****************
 ** WEBPACK FOOTER
 ** ./Content/Scripts/DataModules/app-dropdown.js
 ** module id = 37
 ** module chunks = 5 6 11 14 15
 **/